import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { Task } from '../../../../types';
import { GeometriesListView } from '../../../map/GeometriesList/view';

interface GeometryViewProps {
  task: Task;
}

/**
 * GeometryView displays the map geometries for a task in view mode.
 * Shows all markers, lines, and shapes associated with the task.
 */
export const GeometryView = ({ task }: GeometryViewProps) => {
  const { t } = useTranslation();

  // Early return if no geometries
  if (!task.geometries || task.geometries.length === 0) {
    return (
      <Text size="sm" c="dimmed" ta="center" py="xl">
        {t('geometries.empty')}
      </Text>
    );
  }

  return <GeometriesListView geometries={task.geometries} />;
};
